export default __webpack_public_path__ + "3d70c1536f8d35c17e3053b457c0ae99.png";